import { jsonFetch } from "@/lib/helpers";
import { ALARM_RULES_URL } from "./api-url.constants";
import { AlarmRuleDTO } from "./dtos";

type GetAlarmRulesResponse = {
  data: AlarmRuleDTO[];
};

export const getAlarmRules = async (): Promise<AlarmRuleDTO[]> => {
  const response = await jsonFetch<GetAlarmRulesResponse>(ALARM_RULES_URL);
  return response.data;
};
